function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".axwp-author-byline" + shadowSelector + ",.axwp-author-byline__wrapper" + shadowSelector + " {align-items: center;display: flex;}.axwp-author-byline__name" + shadowSelector + " {font-weight: 700;margin-left: 0.5rem;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];